import { types } from "../types/types"
import { esborrarErrorAction, crearErrorAction, crearTotOkAction, uiActualizarResultatCatAction, uiIniciarFormularioAction, uiActualizarTextosStateAction } from "./ui";



export const addRespuestasCategoria = (token, categoria, tipo, respuestas, IdEvaluacion, calcular = true) => {
    return (dispatch) => {
        const bodyData = JSON.stringify({ categoria, tipo, respuestas, IdEvaluacion, calcular });
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': token },
            credentials: 'include',
            body: bodyData,
            mode: 'cors'
        };
        fetch(process.env.REACT_APP_DOMINI_API_CIUDAD + '/add/categoria', requestOptions)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();
                if (!response.ok) {
                    dispatch(crearErrorAction("Error del servei d'autenticació: " + JSON.stringify(data)));
                } else if (data.ok) {
                    dispatch(crearTotOkAction(calcular ? `Categoria ${categoria} calculada correctamente` : `Respuestas de la categoría ${categoria} guardadas sin calcular`));
                    if (calcular) dispatch(infoCategoria(token, IdEvaluacion));
                    dispatch(esborrarErrorAction());
                } else {
                    dispatch(crearErrorAction(data.msg));
                }
            })
            .catch(error => dispatch(crearErrorAction("No se pudieron guardar las respuestas: " + error.message)));
    };
};


export const iniciarFormulario = (token) => {
    //Aquesta funció (Middleware), retorna un callback. Just quan finalitza la petició, execitarà l'acció 
    return (dispatch) => {
        //dispatch(uiIniciarCarregaAction());      
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'Accept': 'application/json', 'Authorization': token },
            credentials: 'include',
            mode: 'cors'
        };
        //TODO - Crear un fitxer on guardem constants segons l'entorn 
        fetch(process.env.REACT_APP_DOMINI_API_CIUDAD + '/add/formulario', requestOptions)
            .then(async response => {

                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();


                // check for error response
                if (!response.ok) {

                    // get error message from body or default to response status
                    //const error = (data && data.message) || response.status;
                    //dispatch(crearErrorAction("Error del servei d'autenticació: " +  JSON.stringify(data)));
                } else {
                    if (data.ok) {

                        let { IdEvaluacion, IdMunicipio, IdResponsable, DataInicio_Evaluacion, DataFin_Evaluacion, ResultatGlobal } = data.contingut;
                        dispatch(ConfigFormulario(data.contingut));
                        dispatch(uiIniciarFormularioAction())


                        //    dispatch(ConfigFormularioRecuperarConstantesFormulario(data.contingut.ConstantesFormulario));
                        //    dispatch(ConfigFormularioRecuperarIndicadoresFormulario(data.contingut.Indicadores));          
                    } else {
                        dispatch(crearErrorAction(data.msg));
                    }
                }

                //dispatch(uiFinalitzarCarregaAction());
                //element.innerHTML = data.id;
            })
            .catch(error => {
                // element.parentElement.innerHTML = `Error: ${error}`;
                // dispatch(crearErrorAction("Excepció no controlada -  " + JSON.stringify(error)));
                console.error('There was an error!', error);
                // dispatch(uiFinalitzarCarregaAction());
            });

        /*setTimeout(() => {
                //Als 3 segons, farem un dispatch del l'acció Login. 
                
                dispatch(login(123,345,"German, usuari autenticat"));

            }, 3500);*/
    }


}
export const infoCategoria = (token, IdEvaluacion) => {

    //dispatch(uiIniciarCarregaAction());     

    return (dispatch) => {
        var dadesFormulari = {
            'IdEvaluacion': IdEvaluacion,

        };
        //Preparem els parametres post per enviar
        var formBody = [];
        for (var property in dadesFormulari) {
            var encodedKey = encodeURIComponent(property);
            var encodedValue = encodeURIComponent(dadesFormulari[property]);
            formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'Accept': 'application/json', 'Authorization': token },
            credentials: 'include',
            body: formBody,
            mode: 'cors'
        };

        fetch(process.env.REACT_APP_DOMINI_API_CIUDAD + '/info/cat', requestOptions)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();

                if (!response.ok) {
                    dispatch(crearErrorAction("Error del servei d'autenticació: " + JSON.stringify(data)));
                } else {
                    if (data.ok) {
                        dispatch(ConfigFormularioCategoria(data.contingut));


                    } else {




                    }
                }


            })
            .catch(error => {
                console.error('There was an error!', error);

            });

    }

}
export const infoTextCategoria = (token) => {

    //dispatch(uiIniciarCarregaAction());     
    return (dispatch) => {

        //Preparem els parametres post per enviar


        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'Accept': 'application/json', 'Authorization': token },
            credentials: 'include',
            mode: 'cors'
        };

        fetch(process.env.REACT_APP_DOMINI_API_CIUDAD + '/info/textCat', requestOptions)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();

                if (!response.ok) {
                    dispatch(crearErrorAction("Error del servei d'autenticació: " + JSON.stringify(data)));
                } else {
                    if (data.ok) {
                        dispatch(ConfigTextFormularioCategoria(data.contingut));
                        dispatch(uiActualizarTextosStateAction("1"))

                    } else {




                    }
                }


            })
            .catch(error => {
                console.error('There was an error!', error);

            });

    }

}

export const infoPreguntasFormulario = (token) => {
    return (dispatch) => {
        const requestOptions = {
            method: 'GET',
            headers: { 'Accept': 'application/json', 'Authorization': token },
            credentials: 'include',
            mode: 'cors'
        };

        fetch(process.env.REACT_APP_DOMINI_API_CIUDAD + '/info/preguntas', requestOptions)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();
                if (!response.ok) {
                    dispatch(crearErrorAction("Error al cargar preguntas: " + JSON.stringify(data)));
                } else if (data?.ok) {
                    dispatch({ type: types.configFormularioPreguntas, contingut: data.contingut });
                    dispatch(esborrarErrorAction());
                } else {
                    dispatch(crearErrorAction(data?.msg || 'No se pudo cargar la configuración de preguntas'));
                }
            })
            .catch(error => dispatch(crearErrorAction('Error de conexión al cargar las preguntas: ' + error.message)));
    };
};

export const guardarInfoPreguntas = (token, cambios, cambiosCategorias = []) => {
    return (dispatch) => {
        fetch(process.env.REACT_APP_DOMINI_API_CIUDAD + '/info/modInfoPreguntas', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': token },
            credentials: 'include',
            body: JSON.stringify({ cambios, cambiosCategorias }),
            mode: 'cors'
        })
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();
                if (!response.ok || !data?.ok) {
                    dispatch(crearErrorAction(data?.msg || 'No se pudo guardar la información de las preguntas'));
                    return;
                }
                dispatch(crearTotOkAction(data.msg || 'Información guardada correctamente'));
                dispatch(infoPreguntasFormulario(token));
            })
            .catch(error => dispatch(crearErrorAction('Error de conexión al guardar la información: ' + error.message)));
    };
};

export const infoConstantesCategoria = (token) => {

    //dispatch(uiIniciarCarregaAction());     
    return (dispatch) => {

        //Preparem els parametres post per enviar


        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'Accept': 'application/json', 'Authorization': token },
            credentials: 'include',
            mode: 'cors'
        };

        fetch(process.env.REACT_APP_DOMINI_API_CIUDAD + '/info/constCat', requestOptions)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();

                if (!response.ok) {
                    dispatch(crearErrorAction("Error del servei d'autenticació: " + JSON.stringify(data)));
                } else {
                    if (data.ok) {
                        dispatch(ConfigConstantesFormularioCategoria(data.contingut));
                        dispatch(uiActualizarTextosStateAction("1"))

                    } else {




                    }
                }


            })
            .catch(error => {
                console.error('There was an error!', error);

            });

    }

}

export const actualizarVersionConstantes = (token, idVersion) => {

    //dispatch(uiIniciarCarregaAction());     

    return (dispatch) => {
        var dadesFormulari = {
            'idVersion': idVersion,

        };
        //Preparem els parametres post per enviar
        var formBody = [];
        for (var property in dadesFormulari) {
            var encodedKey = encodeURIComponent(property);
            var encodedValue = encodeURIComponent(dadesFormulari[property]);
            formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'Accept': 'application/json', 'Authorization': token },
            credentials: 'include',
            body: formBody,
            mode: 'cors'
        };

        fetch(process.env.REACT_APP_DOMINI_API_CIUDAD + '/mod/VersionConstantes', requestOptions)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();

                if (!response.ok) {
                    dispatch(crearErrorAction("Error del servei d'autenticació: " + JSON.stringify(data)));
                } else {
                    if (data.ok) {
                        dispatch(infoConstantesCategoria(token));

                    } else {




                    }
                }


            })
            .catch(error => {
                console.error('There was an error!', error);

            });

    }

}
export const actualizarVersionIndicadores = (token, idVersion) => {

    //dispatch(uiIniciarCarregaAction());     

    return (dispatch) => {
        var dadesFormulari = {
            'idVersion': idVersion,

        };
        //Preparem els parametres post per enviar
        var formBody = [];
        for (var property in dadesFormulari) {
            var encodedKey = encodeURIComponent(property);
            var encodedValue = encodeURIComponent(dadesFormulari[property]);
            formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'Accept': 'application/json', 'Authorization': token },
            credentials: 'include',
            body: formBody,
            mode: 'cors'
        };

        fetch(process.env.REACT_APP_DOMINI_API_CIUDAD + '/mod/VersionIndicadores', requestOptions)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();

                if (!response.ok) {
                    dispatch(crearErrorAction("Error del servei d'autenticació: " + JSON.stringify(data)));
                } else {
                    if (data.ok) {
                        dispatch(infoIndicadoresCategoria(token));
                    } else {




                    }
                }


            })
            .catch(error => {
                console.error('There was an error!', error);

            });

    }

}
export const infoIndicadoresCategoria = (token) => {
    //dispatch(uiIniciarCarregaAction());     
    return (dispatch) => {

        //Preparem els parametres post per enviar


        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'Accept': 'application/json', 'Authorization': token },
            credentials: 'include',
            mode: 'cors'
        };

        fetch(process.env.REACT_APP_DOMINI_API_CIUDAD + '/info/indicadorCat', requestOptions)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();

                if (!response.ok) {
                    dispatch(crearErrorAction("Error del servei d'autenticació: " + JSON.stringify(data)));
                } else {
                    if (data.ok) {
                        dispatch(ConfigIndicadoresFormularioCategoria(data.contingut));
                        dispatch(uiActualizarTextosStateAction("1"))

                    } else {




                    }
                }


            })
            .catch(error => {
                console.error('There was an error!', error);

            });

    }

}
export const updateTextosModificats = (token, textosModificats, categoria) => {

    //dispatch(uiIniciarCarregaAction());     

    return (dispatch) => {
        const bodyData = JSON.stringify({
            textosModificats: textosModificats,
        });
        //Preparem els parametres post per enviar


        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json', // Enviar como JSON
                'Accept': 'application/json',
                'Authorization': token,
            },
            credentials: 'include',
            body: bodyData,
            mode: 'cors'
        };

        fetch(process.env.REACT_APP_DOMINI_API_CIUDAD + '/info/modText', requestOptions)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();

                if (!response.ok) {
                    dispatch(crearErrorAction("Error del servei d'autenticació: " + JSON.stringify(data)));
                } else {
                    if (data.ok) {
                        dispatch(ActualizarTextoCategoria(categoria, data.contingut));

                    } else {




                    }
                }


            })
            .catch(error => {
                console.error('There was an error!', error);

            });

    }

}
export const updateConstantsModificats = (token, constantsModificats, categoria, version) => {

    //dispatch(uiIniciarCarregaAction());     

    return (dispatch) => {
        const fixedConstants = Object.fromEntries(
            Object.entries(constantsModificats).map(([key, value]) => [String(key), value])
        );

        const bodyData = {
            constantsModificats: fixedConstants,
            version: String(version),
        };

        // Convertimos el objeto en una cadena JSON
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json', // Aseguramos que el servidor sepa que estamos enviando JSON
                'Accept': 'application/json',
                'Authorization': token, // Token de autenticación
            },
            credentials: 'include', // Si necesitas cookies, se puede mantener 'include'
            body: JSON.stringify(bodyData), // Enviamos el cuerpo como JSON
            mode: 'cors', // CORS si es necesario
        };

        fetch(process.env.REACT_APP_DOMINI_API_CIUDAD + '/info/modConst', requestOptions)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();

                if (!response.ok) {
                    dispatch(crearErrorAction("Error del servei d'autenticació: " + JSON.stringify(data)));
                } else {
                    if (data.ok) {

                        dispatch(ActualizarConstantesCategoria(categoria, data.contingut));
                        dispatch(crearTotOkAction("Resultados de la " + categoria + " modificados."));
                    } else {




                    }
                }


            })
            .catch(error => {
                console.error('There was an error!', error);

            });

    }

}
export const updateIndicadorsModificats = (token, indicadorsModificats,estadoIndicador, categoria, version) => {

    //dispatch(uiIniciarCarregaAction());     

    return (dispatch) => {
        const fixedConstants = Object.fromEntries(
            Object.entries(indicadorsModificats).map(([key, value]) => [String(key), value])
        );

        const bodyData = {
            indicadorsModificats: fixedConstants,
            version: version,
            estadoIndicador: estadoIndicador,
            categoria: categoria,
        };

        // Convertimos el objeto en una cadena JSON
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json', // Aseguramos que el servidor sepa que estamos enviando JSON
                'Accept': 'application/json',
                'Authorization': token, // Token de autenticación
            },
            credentials: 'include', // Si necesitas cookies, se puede mantener 'include'
            body: JSON.stringify(bodyData), // Enviamos el cuerpo como JSON
            mode: 'cors', // CORS si es necesario
        };

        fetch(process.env.REACT_APP_DOMINI_API_CIUDAD + '/info/modIndicadors', requestOptions)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();

                if (!response.ok) {
                    dispatch(crearErrorAction("Error del servei d'autenticació: " + JSON.stringify(data)));
                } else {
                    if (data.ok) {
                        const clave = estadoIndicador === 1
                        ? `Categoria${categoria}`
                        : `Categoria${categoria}_Programas`;
                        console.log(data.contingut)
                       dispatch(infoIndicadoresCategoria(token)); 
                        dispatch(crearTotOkAction("Indicadores de la Categoria" + categoria + " modificados."));
                    } else {




                    }
                }


            })
            .catch(error => {
                console.error('There was an error!', error);

            });

    }

}
export const addResultatsCategoria = (token, IdEvaluacion, categoria) => {

    //dispatch(uiIniciarCarregaAction());     

    return (dispatch) => {
        var dadesFormulari = {
            'IdEvaluacion': IdEvaluacion,
        };
        // console.log(dadesFormulari);
        //Preparem els parametres post per enviar
        var formBody = [];
        for (var property in dadesFormulari) {
            var encodedKey = encodeURIComponent(property);
            var encodedValue = encodeURIComponent(dadesFormulari[property]);
            formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'Accept': 'application/json', 'Authorization': token },
            credentials: 'include',
            body: formBody,
            mode: 'cors'
        };

        fetch(process.env.REACT_APP_DOMINI_API_CIUDAD + '/resultat/' + categoria, requestOptions)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();

                if (!response.ok) {
                    dispatch(crearErrorAction("Error del servei d'autenticació: " + JSON.stringify(data)));
                } else {
                    if (data.ok) {
                        dispatch(crearTotOkAction("Resultados de la categoria" + categoria + " "));
                        dispatch(resultatsCategoria(data.contingut));
                        dispatch(uiActualizarResultatCatAction(true));
                    } else {
                        dispatch(crearErrorAction(data.msg));
                    }
                }
            })
            .catch(error => {
                console.error('There was an error!', error);

            });
    }

}



// ── Thunks ───────────────────────────────────────────────────────────────────
export const getTextosPDF = (token) => {
    return (dispatch) => {
        fetch(process.env.REACT_APP_DOMINI_API_CIUDAD + '/pdf/textos', {
            method: 'GET',
            headers: { 'Accept': 'application/json', 'Authorization': token },
            credentials: 'include',
            mode: 'cors',
        })
        .then(async res => {
            const data = await res.json();
            if (data.ok) {
                dispatch(TextosPDFRecuperarInfoFinalitzat(data.contingut));
            } else {
                dispatch(crearErrorAction(data.msg || 'Error al cargar textos PDF'));
            }
        })
        .catch(err => console.error('Error getTextosPDF:', err));
    };
};

export const modificarTextoPDF = (token, idTextoPDF, texto) => {
    return (dispatch) => {
        fetch(process.env.REACT_APP_DOMINI_API_CIUDAD + '/pdf/modificarTexto', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': token },
            credentials: 'include',
            body: JSON.stringify({ IdTextoPDF: idTextoPDF, Texto: texto }),
            mode: 'cors',
        })
        .then(async res => {
            const data = await res.json();
            if (data.ok) {
                dispatch(TextosPDFActualizarTexto(idTextoPDF, texto));
                dispatch(crearTotOkAction('Texto guardado correctamente.'));
            } else {
                dispatch(crearErrorAction(data.msg || 'Error al guardar'));
            }
        })
        .catch(err => console.error('Error modificarTextoPDF:', err));
    };
};


// ── POST /pdf/generar ─────────────────────────────────────────────────────────
export const generarInforme = (token, IdEvaluacion) => {
    return (dispatch) => {
        var dadesFormulari = { 'IdEvaluacion': IdEvaluacion };
        var formBody = [];
        for (var property in dadesFormulari) {
            formBody.push(encodeURIComponent(property) + '=' + encodeURIComponent(dadesFormulari[property]));
        }
        formBody = formBody.join('&');
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'Accept': 'application/json', 'Authorization': token },
            credentials: 'include',
            body: formBody,
            mode: 'cors'
        };
        dispatch({ type: '[PDF] Generar Loading', payload: true });
        fetch(process.env.REACT_APP_DOMINI_API_CIUDAD + '/pdf/generar', requestOptions)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();
                if (!response.ok) {
                    dispatch(crearErrorAction('Error al generar informe: ' + JSON.stringify(data)));
                    dispatch({ type: '[PDF] Generar Loading', payload: false });
                } else {
                    if (data.ok) {
                        dispatch({ type: '[PDF] Generar OK', payload: data.contingut });
                        dispatch(crearTotOkAction(
                            data.contingut.emailOk
                                ? `✅ Informe generado y enviado a ${data.contingut.email}`
                                : `✅ Informe generado. No se pudo enviar el email.`
                        ));
                    } else {
                        dispatch(crearErrorAction(data.msg));
                    }
                    dispatch({ type: '[PDF] Generar Loading', payload: false });
                }
            })
            .catch(error => {
                console.error('generarInforme error:', error);
                dispatch(crearErrorAction('Error de conexión al generar el informe.'));
                dispatch({ type: '[PDF] Generar Loading', payload: false });
            });
    }
}







export const TextosPDFRecuperarInfoFinalitzat = (contingut) => ({
    type: types.textosPDFRecuperarInfo,
    payload: { contingut }
});

export const TextosPDFActualizarTexto = (idTextoPDF, texto) => ({
    type: types.textosPDFActualizarTexto,
    payload: { idTextoPDF, texto }
});
export const resultatsCategoria = (contingut) => {
    return {
        type: types.configFormularioResultats,
        contingut
    }

}


export const ConfigFormulario = (contingut) => {
    return {
        type: types.configFormularioInfo,
        contingut
    }

}
export const ConfigFormularioCategoria = (contingut) => {
    return {
        type: types.configFormularioCategoria,
        contingut
    }

}
export const ConfigTextFormularioCategoria = (contingut) => {
    return {
        type: types.configTextFormularioCategoria,
        contingut,
    }

}
export const ConfigConstantesFormularioCategoria = (contingut) => {
    return {
        type: types.configConstantesFormularioCategoria,
        contingut,
    }

}
export const ConfigIndicadoresFormularioCategoria = (contingut) => {
    return {
        type: types.configIndicadoresFormularioCategoria,
        contingut,
    }

}
export const ActualizarTextoCategoria = (categoria, nuevosTextos) => {
    return {
        type: types.configActualizarTextoCategoria,
        categoria, // El nombre de la categoría que estás actualizando (ej. "categoria2")
        nuevosTextos, // El objeto con los textos modificados, ej. { "Cat2_Preg6": "Nuevo texto" }
    };
};
export const ActualizarConstantesCategoria = (categoria, nuevasConstantes) => {
    return {
        type: types.configActualizarConstantesCategoria,
        categoria, // El nombre de la categoría que estás actualizando (ej. "categoria2")
        nuevasConstantes, // El objeto con los textos modificados, ej. { "Cat2_Preg6": "Nuevo texto" }
    };
};
export const ActualizarIndicadoresCategoria = (categoria, nuevasIndicadores) => {
    return {
        type: types.configActualizarIndicadoresCategoria,
        categoria, // El nombre de la categoría que estás actualizando (ej. "categoria2")
        nuevasIndicadores, // El objeto con los textos modificados, ej. { "Cat2_Preg6": "Nuevo texto" }
    };
};
